// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1ajHh","remove":"File_remove__Yvbt9"};